// Quita acentos y normaliza mayúsculas para que "gestion" encuentre "Gestión".
export function normalizeText(value) {
  return (value || "")
    .toString()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}

/**
 * Aplana el árbol completo (sin importar si un nodo está colapsado) en una
 * lista de { item, path }, donde `path` es la cadena de nombres de los
 * ancestros. Es la base tanto de la búsqueda como de la resolución de
 * favoritos/recientes por id.
 */
export function flattenAll(tree, path = []) {
  const rows = [];
  for (const item of tree) {
    const currentPath = [...path, item.name];
    rows.push({ item, path });
    if (item.children?.length) {
      rows.push(...flattenAll(item.children, currentPath));
    }
  }
  return rows;
}

/**
 * Filtra el árbol completo por texto y devuelve resultados PLANOS (no
 * anidados): cada resultado trae su "breadcrumb" para dar contexto sin
 * obligar al usuario a expandir categorías manualmente. Solo se listan
 * hojas navegables (con ruta real) — las categorías puras no son un
 * destino útil en resultados de búsqueda.
 */
export function searchMenuTree(tree, query) {
  const needle = normalizeText(query);
  if (!needle) return [];

  return flattenAll(tree)
    .filter(({ item }) => Boolean(item.route) && normalizeText(item.name).includes(needle))
    .map(({ item, path }) => ({ item, breadcrumb: path.join(" › ") }));
}

/**
 * Convierte el árbol en una lista lineal de filas visibles, respetando qué
 * categorías están expandidas. Es lo que consume tanto el render en árbol
 * normal como el modo virtualizado, para que ambos vean exactamente las
 * mismas filas.
 */
export function flattenVisibleRows(tree, openSubMenus, depth = 0) {
  const rows = [];
  for (const item of tree) {
    rows.push({ item, depth });
    const hasChildren = item.children?.length > 0;
    if (hasChildren && openSubMenus[item.id]) {
      rows.push(...flattenVisibleRows(item.children, openSubMenus, depth + 1));
    }
  }
  return rows;
}
